import React from "react";

/**
 * Wazi mark — elongated green chat bubble with white lowercase "w".
 * Egg-shaped with a soft pointed tail at bottom-left, matching the user's reference.
 */
export const WaziMark = ({ size = 36, className = "" }) => (
  <svg
    width={size}
    height={(size * 80) / 60}
    viewBox="0 0 60 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Wazi"
  >
    {/* Egg-shaped bubble with bottom-left tail */}
    <path
      d="M30 3
         C 13.5 3, 3 15, 3 31
         C 3 43, 9 53, 18 58
         C 17 63, 13 70, 6 75
         C 5.4 75.8, 5.8 77, 6.8 76.8
         C 16 75.3, 23 71, 26 65
         C 27.3 65.3, 28.6 65.5, 30 65.5
         C 46.5 65.5, 57 53, 57 35
         C 57 17, 46.5 3, 30 3 Z"
      fill="#25D366"
    />
    {/* Handwritten lowercase w — chunky white strokes */}
    <path
      d="M14 22 L22 46 L30 30 L38 46 L46 22"
      stroke="#FFFFFF"
      strokeWidth="5.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

/**
 * Round chat-avatar variant — used inside the WhatsApp simulator header
 * AND as the favicon. Rounded green square, white chat bubble inside,
 * green W-with-checkmark (right stroke extends up into a check).
 */
export const WaziChatAvatar = ({ size = 40, className = "", rounded = true }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Wazi"
  >
    {rounded && <rect width="100" height="100" rx="22" fill="#25D366" />}
    <path
      d="M52 18C33.222 18 18 32.252 18 49.85c0 6.66 2.18 12.86 5.92 18.04L18.6 79.85c-.5 1.12.55 2.32 1.74 1.99l11.27-3.12A35.96 35.96 0 0 0 52 81.85c18.778 0 34-13.998 34-31.997C86 32.252 70.778 18 52 18Z"
      fill="#FFFFFF"
    />
    <path
      d="M32 40 L41 66 L49 50 L57 66 L78 28"
      stroke="#25D366"
      strokeWidth="7.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export const WaziWordmark = ({ size = 28, withMark = true, className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    {withMark && <WaziChatAvatar size={size * 1.15} />}
    <span
      className="font-heading font-bold tracking-tight text-[#1E88E5]"
      style={{ fontSize: size * 1.15, lineHeight: 1, letterSpacing: "-0.04em" }}
    >
      Wazi
    </span>
  </div>
);

export default WaziWordmark;

